module.exports = __webpack_public_path__ + "static/RamanMahesh-031a1ef1ef5902e19601fcbf02195f70.jpg";